export const queryParamFilter: { [x: string]: string } = {
	TypeOfAccess: 'access',
	LearningTopics: 'topics',
	TypeOfResources: 'resources',
	TypeOfLearning: 'learning',
	NursingRoles: 'roles',
	RcniLearningCategories: 'rcniCategories',
};

export const searchContentQueryString = (filterName: string, url?: string, id?: string) => {
	return `${url?.substring(0, url.lastIndexOf('/')) ?? ''}?q=&${queryParamFilter[filterName]}=${id}`;
};

export const updateSearchQueryString = (url: string, newTopic: string) => {
	const fullUrl = new URL(url, window.location.origin);
	const params = fullUrl.searchParams;

	// Get existing topics
	const rawTopics = params.get('topics') || '';

	// Split, clean, and filter out any malformed "topics=..." entries
	const existingTopics = rawTopics
		.split(',')
		.map((t) => t.replace(/^topics=/, '').trim())
		.filter(Boolean);

	// Clean newTopic just in case
	const cleanedTopic = newTopic.replace(/^topics=/, '').trim();

	// Only add if it doesn't exist already
	if (!existingTopics.includes(cleanedTopic)) {
		existingTopics.push(cleanedTopic);
	}

	// Set clean topics back to params
	params.set('topics', existingTopics.join(','));

	return fullUrl.pathname + '?' + params.toString();
};
